export default __webpack_public_path__ + "static/media/icn_bluetooth.8b0ad2a3.svg";